import React from "react";
import PropTypes from "prop-types";
import {
  RadioGroupContainer,
  RadioGroupTitle,
  RadioOptionsContainer,
  RadioOption,
  RadioInput,
  RadioLabel,
} from "./RadioGroup.styles";

const RadioGroup = ({
  title,
  options = [],
  value,
  onChange,
  name,
  className = "",
  disabled = false,
  variant = "default",
}) => {
  const handleOptionChange = (optionValue) => {
    if (!disabled && onChange) {
      onChange(optionValue);
    }
  };

  return (
    <RadioGroupContainer className={className} variant={variant}>
      {title && <RadioGroupTitle>{title}</RadioGroupTitle>}

      <RadioOptionsContainer>
        {options.map((option) => (
          <RadioOption
            key={option.id || option.value}
            isSelected={value === option.value}
            disabled={disabled}
            onClick={() => handleOptionChange(option.value)}
          >
            <RadioInput
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => handleOptionChange(option.value)}
              disabled={disabled}
            />
            <RadioLabel isSelected={value === option.value}>
              {option.label}
            </RadioLabel>
          </RadioOption>
        ))}
      </RadioOptionsContainer>
    </RadioGroupContainer>
  );
};

RadioGroup.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "card"]),
};

export default RadioGroup;
